import FormFieldController from "confinus_ui/forms/form_field_controller";

export default class TextAreaController extends FormFieldController {}
